module.exports = __webpack_public_path__ + "static/imagen_02-7b63e78da01edff55b819d13372133fd.jpg";